/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GuidanceStatus = {
    Active: 'Active',
    Dismissed: 'Dismissed'
} as const;
export type GuidanceStatus = typeof GuidanceStatus[keyof typeof GuidanceStatus];


export function GuidanceStatusFromJSON(json: any): GuidanceStatus {
    return GuidanceStatusFromJSONTyped(json, false);
}

export function GuidanceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidanceStatus {
    return json as GuidanceStatus;
}

export function GuidanceStatusToJSON(value?: GuidanceStatus | null): any {
    return value as any;
}

